
const TechnologyStack = () => {
  const technologies = [
    {
      icon: 'ri-database-2-line',
      title: 'Veri Toplama',
      description: 'Gerçek zamanlı piyasa verisi akışı',
      details: 'Borsa İstanbul\'dan gelen fiyat, hacim ve teknik gösterge verileri milisaniyeler içinde toplanır ve işlenir.',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Algoritmik Analiz',
      description: 'Çoklu gösterge değerlendirmesi',
      details: 'Milyonlarca verinin işlenmesi ve yüz binlerce niceliksel analiz sonucu algoritmik karar üretilir.',
    },
    {
      icon: 'ri-brain-line',
      title: 'Makine Öğrenimi',
      description: 'Akıllı karar üretimi',
      details: 'Derin öğrenme modelleri, geçmiş verileri analiz ederek gelecekteki fiyat hareketlerini tahmin eder.',
    },
    {
      icon: 'ri-speed-line',
      title: 'Hızlı İşleme',
      description: 'Düşük gecikme süresi',
      details: 'Optimize edilmiş algoritmalar sayesinde karar üretim süresi 1 saniyenin altındadır.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Güvenilirlik',
      description: 'Yüksek doğruluk oranı',
      details: 'Sürekli test edilen ve geliştirilen modeller, yüksek doğruluk oranı sağlar.',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Sürekli Güncelleme',
      description: 'Canlı veri akışı',
      details: 'Sistem 7/24 çalışır ve piyasa açık olduğu sürece kesintisiz karar üretir.',
    },
  ];

  return (
    <section className="py-32 bg-dark-lighter relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-beige-light mb-6">
            Teknoloji Altyapısı
          </h2>
          <p className="text-xl text-beige/70 max-w-3xl mx-auto">
            BAGA, modern fintech teknolojilerini bir araya getirerek güçlü bir algoritmik karar üretim sistemi oluşturur
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {technologies.map((tech, index) => (
            <div
              key={index}
              className="bg-dark-card border border-dark-border rounded-2xl p-8 hover:border-emerald/30 hover:shadow-xl hover:shadow-emerald/5 transition-all group"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-emerald to-emerald-light rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${tech.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-beige-light mb-2 group-hover:text-emerald transition-colors">
                {tech.title}
              </h3>
              
              <p className="text-emerald text-sm font-semibold mb-4">
                {tech.description}
              </p>
              
              <p className="text-beige/70 text-sm leading-relaxed">
                {tech.details}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechnologyStack;
